import { useState } from "react";
//import CartButton from "../CartButton";
import HamburgerButton from "./HamburgerButton";
//import { GrLanguage } from "react-icons/gr";
import NavItems from "./NavItems";
import ToolsMenu from "./ToolsMenu";
import { useSwipe } from "../../../../hooks/useSwipe";

export default function NavBar({showHeader}: {showHeader: boolean}) {
	const [isActiveHamburgerButton, setIsActiveHamburgerButton] = useState<boolean>(false);
	const { 
		onTouchStart, 
		onTouchEnd, 
		onMouseDown,
		onMouseUp 
	} = useSwipe({
		onSwipeRight: () => setIsActiveHamburgerButton(false)
	});

	return (
		<>
			<HamburgerButton
				isActiveHamburgerButton={isActiveHamburgerButton}
				setIsActiveHamburgerButton={setIsActiveHamburgerButton}
			/>
			<nav
				onTouchStart={onTouchStart}
  				onTouchEnd={onTouchEnd}
				onMouseDown={onMouseDown}
				onMouseUp={onMouseUp}
				className={`
					fixed md:static top-0 right-0 z-900
					text-navbar-text-color
					w-screen md:w-[70%] 
					px-10 py-20 md:p-0
					h-full md:h-auto overflow-auto md:overflow-visible 2xl:overflow-visible
					${isActiveHamburgerButton ? "translate-x-0" : "translate-x-[100%]"} 
					md:translate-x-0 duration-700 md:duration-0 ease-out transition-transform
					flex justify-start md:justify-end items-start md:items-center flex-col md:flex-row gap-5 2xl:gap-[3vw]
					bg-[#FF9E0B]/100 md:bg-transparent
					text-md lg:text-xl 2xl:text-[1.6vw] select-none
            	`}
			>
				<NavItems
					setIsActiveHamburgerButton={setIsActiveHamburgerButton}
				/>
				<div className="flex flex-col md:flex-row gap-5 md:gap-5 2xl:gap-[1.5vw] font-normal]">
					<ToolsMenu showHeader={showHeader} />
				</div>
			</nav>
		</>
	);
}